import { introConfig, introEnabled, revealEndMs } from "./config/motion";
import { interactionConfig } from "./config/ui";
import { requireElement } from "./dom";

(() => {
	"use strict";
	const root = document.documentElement;
	const scene = requireElement(".experience");
	const content = [
		...document.querySelectorAll<HTMLElement>("[data-intro-reveal]"),
	];
	const reduced = window.matchMedia(interactionConfig.reducedMotionQuery);
	let phase: "done" | "waiting" | "docking" | "revealing" =
		!introEnabled || reduced.matches ? "done" : "waiting";
	let dockTimer: number | undefined, revealTimer: number | undefined;
	let renderScale = 1;

	function unlockContent() {
		content.forEach((element) => {
			element.inert = false;
		});
	}
	function finish() {
		phase = "done";
		window.clearTimeout(dockTimer);
		window.clearTimeout(revealTimer);
		root.classList.remove(
			"intro-active",
			"intro-centered",
			"intro-prepared",
			"intro-docking",
			"intro-revealing",
		);
		scene.style.removeProperty("transform");
		unlockContent();
	}
	function reveal() {
		phase = "revealing";
		root.classList.remove(
			"intro-centered",
			"intro-prepared",
			"intro-docking",
		);
		scene.style.removeProperty("transform");
		root.classList.add("intro-revealing");
		unlockContent();
		revealTimer = window.setTimeout(finish, revealEndMs);
	}
	function dock() {
		if (phase !== "waiting") return;
		if (reduced.matches) return finish();
		phase = "docking";
		root.classList.add("intro-docking");
		scene.style.transform = "translate3d(0, 0, 0) scale(1)";
		dockTimer = window.setTimeout(
			reveal,
			introConfig.dockDurationMs + introConfig.dockSettleMs,
		);
	}
	if (phase === "waiting") {
		root.classList.add("intro-active", "intro-centered");
		content.forEach((element) => {
			element.inert = true;
		});
		const rect = scene.getBoundingClientRect();
		const scale = Math.min(
			introConfig.maxScale,
			(window.innerWidth * introConfig.viewportWidthRatio) /
				Math.max(rect.width, 1),
			(window.innerHeight * introConfig.viewportHeightRatio) /
				Math.max(rect.height, 1),
		);
		// Allocate enough canvas pixels for the largest displayed size, once.
		renderScale = Math.max(1, scale);
		const x = window.innerWidth / 2 - rect.left - rect.width / 2;
		const y = window.innerHeight / 2 - rect.top - rect.height / 2;
		scene.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${scale})`;
		root.classList.add("intro-prepared");
	} else finish();

	window.addEventListener("resize", () => {
		if (phase !== "done") finish();
	});
	reduced.addEventListener("change", (event) => {
		if (event.matches) finish();
	});
	window.pixelIntro = {
		dock,
		finish,
		get renderScale() {
			return renderScale;
		},
		get active() {
			return phase !== "done";
		},
		get centered() {
			return phase === "waiting";
		},
	};
})();
